package com.dotdrives.web.pages.updates

import com.dotdrives.controller.NewReportController
import com.dotdrives.controller.NewReportUiState
import com.dotdrives.controller.UpdatesController
import com.dotdrives.controller.UpdatesUiState
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.useEffect
import react.useState
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface UpdatesPageProps : Props {
    var updatesController: UpdatesController
    var updatesState: UpdatesUiState
    var newReportController: NewReportController
    var newReportState: NewReportUiState
    var currentUserId: String
    var isStaff: Boolean
}

val UpdatesPage = FC<UpdatesPageProps> { props ->
    val (newOpen, setNewOpen) = useState(false)

    val savedReportId = props.newReportState.savedReportId
    useEffect(savedReportId) {
        if (savedReportId != null) {
            setNewOpen(false)
            props.updatesController.load()
            props.updatesController.select(savedReportId)
            props.newReportController.start()
        }
    }

    UpdatesStyles()

    div {
        className = ClassName("updates-page")

            div {
                className = ClassName("updates-split")
                UpdatesList {
                    totalCount = props.updatesState.board.totalCount
                    unreadCount = props.updatesState.board.unreadCount
                    hasMore = props.updatesState.board.nextCursor != null
                    loadingMore = props.updatesState.loadingMore
                    onLoadMore = props.updatesController::loadMore
                    loading = props.updatesState.loading
                    reports = props.updatesState.reports
                    visibleReports = props.updatesState.visibleReports
                    filters = props.updatesState.filters
                    selectedReportId = props.updatesState.selectedReportId
                    error = props.updatesState.error
                    onFilterChange = props.updatesController::setFilters
                    onSelect = props.updatesController::select
                    onRetry = props.updatesController::load
                    onNewUpdate = {
                        props.newReportController.start()
                        setNewOpen(true)
                    }
                }
                ThreadPanel {
                    state = props.updatesState
                    controller = props.updatesController
                    currentUserId = props.currentUserId
                    isStaff = props.isStaff
                    onShare = props.updatesController::startShare
                }
            }
    }

    if (newOpen) {
        NewUpdateDialog {
            state = props.newReportState
            controller = props.newReportController
            targets = props.updatesState.targets
            defaultUpdates = props.updatesState.defaultUpdates
            onClose = { setNewOpen(false) }
        }
    }

    if (props.updatesState.shareOpen) {
        ShareDialog {
            state = props.updatesState
            controller = props.updatesController
            onClose = props.updatesController::closeShare
        }
    }
}
